module.exports = __webpack_public_path__ + "img/loader.1d7626e6.gif";